import * as tslib_1 from "tslib";
import * as React from "react";
import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Sidebar from "./components/Sidebar";
import Routes from "./config/routes";
import Login from "./views/Login";
import { connect } from "react-redux";
import axios from "axios";
import { API_URL } from "./config/urls";
import { updateAuthToken, updateSAdmin } from "./actions/app";
import ReduxToastr from 'react-redux-toastr';
var App = /** @class */ (function (_super) {
    tslib_1.__extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        var authToken = localStorage.getItem('authToken');
        if (authToken && authToken.length > 0) {
            axios.get(API_URL + "/user/check", {
                headers: { 'Authorization': 'Bearer ' + authToken }
            })
                .then(function (resp) {
                if (!resp.data || !resp.data.code || resp.data.code !== 200) {
                    // @ts-ignore
                    _this.props.dispatch(updateAuthToken(''));
                    localStorage.removeItem("authToken");
                }
                if (resp.data.data && resp.data.data.roles && resp.data.data.roles.indexOf("sadmin") > -1) {
                    // @ts-ignore
                    _this.props.dispatch(updateSAdmin(true));
                }
                else {
                    // @ts-ignore
                    _this.props.dispatch(updateSAdmin(false));
                }
            })
                .catch(function (err) {
                console.log(err.message);
            });
        }
        return _this;
    }
    App.prototype.render = function () {
        console.log("RENDER APP");
        if (!this.props.authToken) {
            return React.createElement(Login, null);
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Header, null),
            React.createElement(ReduxToastr, { timeOut: 4000, newestOnTop: false, preventDuplicates: true, position: 'top-right', transitionIn: 'fadeIn', transitionOut: 'fadeOut', progressBar: true }),
            React.createElement("div", { className: "m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body" },
                React.createElement("button", { className: "m-aside-left-close  m-aside-left-close--skin-dark ", id: "m_aside_left_close_btn" },
                    React.createElement("i", { className: "la la-close" })),
                React.createElement(Sidebar, null),
                React.createElement("div", { className: "m-grid__item m-grid__item--fluid m-wrapper" },
                    React.createElement("div", { className: "m-content" },
                        React.createElement(Routes, null)))),
            React.createElement(Footer, null)));
    };
    return App;
}(React.Component));
export default connect(function (state) { return ({
    authToken: state.app.get("auth_token"),
    router: state.router
}); })(App);



//////////////////
// WEBPACK FOOTER
// ./src/App.tsx
// module id = 291
// module chunks = 0